import React from 'react';
import { Box, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FlightTakeoffIcon from '@material-ui/icons/FlightTakeoff';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: '100vh',
    display: 'flex',
    background:
      'linear-gradient(135deg, #4f46e5 0%, #7c3aed 45%, #ec4899 100%)',
    position: 'relative',
    overflow: 'hidden',
    '&::before, &::after': {
      content: '""',
      position: 'absolute',
      borderRadius: '50%',
      filter: 'blur(80px)',
      opacity: 0.35,
      pointerEvents: 'none',
    },
    '&::before': {
      width: 480,
      height: 480,
      background: '#22d3ee',
      top: -120,
      left: -120,
    },
    '&::after': {
      width: 520,
      height: 520,
      background: '#f472b6',
      bottom: -160,
      right: -160,
    },
  },
  brandPanel: {
    flex: 1,
    color: '#fff',
    padding: theme.spacing(8),
    display: 'none',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'relative',
    zIndex: 1,
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  brandTop: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    fontWeight: 700,
    fontSize: '1.5rem',
    letterSpacing: '-0.02em',
  },
  brandIcon: {
    width: 44,
    height: 44,
    borderRadius: 12,
    background: 'rgba(255,255,255,0.18)',
    backdropFilter: 'blur(8px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  brandTagline: {
    maxWidth: 480,
  },
  taglineTitle: {
    fontSize: '2.75rem',
    fontWeight: 800,
    lineHeight: 1.1,
    letterSpacing: '-0.03em',
    marginBottom: theme.spacing(2),
  },
  taglineSubtitle: {
    fontSize: '1.1rem',
    opacity: 0.9,
    lineHeight: 1.6,
  },
  brandFooter: {
    fontSize: '0.85rem',
    opacity: 0.75,
  },
  formPanel: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
    position: 'relative',
    zIndex: 1,
  },
  paper: {
    padding: theme.spacing(5),
    borderRadius: 24,
    width: '100%',
    maxWidth: 440,
    backdropFilter: 'blur(12px)',
    backgroundColor: 'rgba(255,255,255,0.96)',
    boxShadow: '0 30px 80px rgba(17,24,39,0.18)',
  },
  logo: {
    fontWeight: 800,
    background: 'linear-gradient(135deg, #4f46e5, #ec4899)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    letterSpacing: '-0.02em',
    marginBottom: theme.spacing(0.5),
  },
  title: {
    color: '#475569',
    marginBottom: theme.spacing(3.5),
    fontWeight: 500,
  },
}));

const AuthLayout = ({ children }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.brandPanel}>
        <Box className={classes.brandTop}>
          <Box className={classes.brandIcon}>
            <FlightTakeoffIcon />
          </Box>
          Voyage Admin
        </Box>
        <Box className={classes.brandTagline} classes={{ root: 'fade-in-up' }}>
          <Typography className={classes.taglineTitle}>
            Pilotez votre plateforme de voyages en toute simplicité.
          </Typography>
          <Typography className={classes.taglineSubtitle}>
            Réservations, véhicules, itinéraires et paiements — tout dans une
            interface moderne, rapide et sécurisée.
          </Typography>
        </Box>
        <Typography className={classes.brandFooter}>
          © {new Date().getFullYear()} Voyage. Tous droits réservés.
        </Typography>
      </Box>

      <Box className={classes.formPanel}>
        <Paper className={`${classes.paper} fade-in-up`} elevation={0}>
          <Typography variant="h4" className={classes.logo}>
            Voyage
          </Typography>
          <Typography variant="body1" className={classes.title}>
            Panel d'administration
          </Typography>
          {children}
        </Paper>
      </Box>
    </Box>
  );
};

export default AuthLayout;
